module.exports = __webpack_public_path__ + "img/tagIconAddHover.d0403547.svg";